import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const LoadingSkeleton = () => (
  <Styles.SkeletonContainer>
    {[1, 2, 3].map(i => (
      <Styles.SkeletonRow key={i}>
        <Skeleton width="32px" height="32px" borderRadius="8px" />
        <Skeleton width="200px" height="16px" borderRadius="4px" />
      </Styles.SkeletonRow>
    ))}
  </Styles.SkeletonContainer>
)

export default LoadingSkeleton
